<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    mobile-break-point="960"
    app
    width="260"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      />
    </template>

    <v-divider class="mb-1" />

    <v-list
      dense
      nav
    >
      <v-list-item>
        <v-list-item-avatar
          size="60"
        >
          <v-img
            lazy-src="../../assets/logo11.jpg"
            src="../../assets/logo11.jpg"
          />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title
            class="display-1"
            color="red"
            text
          />
          SPEED BRAKE C.A
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider class="mb-1" />

    <v-list>
      <v-list-group
        v-for="(item, icon, i) in computedItems"
        :key="i"
        v-model="item.active"
        :prepend-icon="item.icon"
        no-action
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title v-text="item.title" />
          </v-list-item-content>
        </template>
        <v-list-item
          v-for="child in item.submenu"
          :key="child.title"
          link
          :to="child.to"
        >
          <v-list-item-content>
            <v-list-item-title v-text="child.title" />
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import {
    mapState,
  } from 'vuex'

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      items: [
        {
          icon: 'mdi-home-city-outline',
          title: 'Maestros',
          submenu: [
            {
              title: 'Tipo de Productos',
              icon: 'mdi-beaker-outline',
              to: '/pages/Productos',
            },
            {
              title: 'Marca del Producto',
              icon: 'mdi-beaker-outline',
              to: '/pages/MarcaP',
            },
            {
              title: 'Marca del Vehiculo',
              icon: 'mdi-clipboard-outline',
              to: '/pages/Marcas',
            },
            {
              title: 'Modelo del Vehiculo',
              icon: 'mdi-clipboard-outline',
              to: '/pages/Modelo',
            },
            {
              title: 'Usuarios',
              icon: 'mdi-clipboard-outline',
              to: '/pages/usuarios',
            },
          ],
        },
        {
          icon: 'mdi-cog',
          title: 'Operaciones',
          submenu: [
            {
              title: 'Inventario',
              icon: 'mdi-clipboard-outline',
              to: '/pages/Inventario',
            },
            {
              title: 'Clientes',
              icon: 'mdi-clipboard-outline',
              to: '/pages/Clientes',
            },
            {
              title: 'Orden de trabajo',
              icon: 'mdi-clipboard-outline',
              to: '/pages/orden',
            },
          ],
        },
      ],
    }),

    computed: {
      ...mapState(['barColor', 'barImage']),
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },
      computedItems () {
        return this.items.map(this.mapItem)
      },
      profile () {
        return {
          avatar: true,
          title: this.$t('avatar'),
        }
      },
    },

    methods: {
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title),
        }
      },
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
